import { DashboardPanel } from '../ui/dashboard-panel';
import { FC, PropsWithChildren } from 'react';

export interface WidgetProps {
  title?: string | undefined | null;
  secondaryText?: number | string | undefined | null;
  collapsible?: boolean;
  classNames?: any;
}

export const WidgetNivo: FC<PropsWithChildren<WidgetProps>> = ({
  title,
  children,
  secondaryText,
  classNames,
  collapsible = false,
}) => {
  return (
    <DashboardPanel
      collapsible={collapsible}
      classNames={classNames}
      header={
        title != null && (
          <h2 className="mx-auto select-text pt-2 text-lg font-medium text-slate-300">
            {title}
          </h2>
        )
      }
    >
      <div>
        {secondaryText != null && (
          <p className="items-center py-4 text-center text-5xl">
            {secondaryText}
          </p>
        )}
        <div>{children}</div>
      </div>
    </DashboardPanel>
  );
};